<template>
  <ul :class="[params.producers?.length > 1 ? 'list-disc' : '']">
    <li v-for="(producer, index) in params.producers" :key="index">
      {{ producer.fullname }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FormerProducerColumnn'
}
</script>
